import { takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import * as usersActions from './actions';
import { apiSagaV2 } from '../../../helpers/saga';
import { AdminApi } from 'src/api';

const getUsersSaga = apiSagaV2(usersActions.getUsers, async (connection, action) => {
  const { page, searchText } = action.payload;

  return new AdminApi(connection).getUsers(page, searchText);
});

const editUserSaga = apiSagaV2(usersActions.editUser, async (connection, action) => {
  const { userId, data } = action.payload;

  return new AdminApi(connection).editUser(userId, data);
});

export function* usersSagas() {
  yield takeEvery(getType(usersActions.getUsers.request), getUsersSaga);
  yield takeEvery(getType(usersActions.editUser.request), editUserSaga);
}
